export const DurationSelector = {
  attributes: {
    durationValue: "duration-selector-value",
    durationUnit: "duration-selector-unit"
  }
};
